import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  // Close mobile menu when route changes
  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  const menuItems = [
    { label: "Home", href: "/home" },
    { label: "About", href: "/about" },
    { label: "Our Team", href: "/team" }
  ];

  return (
    <nav className="relative z-50" aria-label="Primary">
      <div className="flex justify-between items-center py-4 px-4 md:px-20 bg-white">
        <Link to="/home" className="w-1/2 md:w-1/4 lg:w-1/6 xl:w-1/12 inline-flex items-center focus:outline-none focus:ring-2 focus:ring-black rounded">
          <img src="/Assets/Images/logo.svg" alt="Project Sunflower Lanyard logo with a bright yellow half sunflower icon next to the text, on a purple background." className="min-w-[8rem]" />
        </Link>
        
        {/* Desktop Menu */}
        <div className="hidden md:flex justify-end w-1/2 md:w-3/4 lg:w-5/6 xl:w-11/12">
          <ul className="flex justify-end items-center space-x-4 gap-[25px]">
            {menuItems.map((item, index) => {
              const isActive = location.pathname === item.href;
              return (
                <li key={index} className="font-semibold">
                  <Link 
                    to={item.href} 
                    className={isActive ? "active-link" : "hover:text-gray-600 transition-colors"}
                  >
                    {item.label}
                  </Link>
                </li>
              );
            })}
            <li>
              <button
                className="bg-black text-white text-lg font-bold px-6 py-2 rounded hover:bg-gray-800 transition-colors"
                onClick={() => navigate("/auth")}
              >
                Login
              </button>
            </li>
          </ul>
        </div>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden p-2 focus:outline-none"
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Toggle menu"
          aria-expanded={isOpen}
          aria-controls="mobile-menu-panel"
        >
          <div className="w-6 h-4 relative flex flex-col justify-between">
            <span className={`w-full h-0.5 bg-black transition-transform duration-300 ${isOpen ? 'rotate-45 translate-y-1.5' : ''}`} />
            <span className={`w-full h-0.5 bg-black transition-opacity duration-300 ${isOpen ? 'opacity-0' : ''}`} />
            <span className={`w-full h-0.5 bg-black transition-transform duration-300 ${isOpen ? '-rotate-45 -translate-y-1.5' : ''}`} />
          </div>
        </button>
      </div>

      {/* Mobile Menu Overlay */}
      <div
        className={`fixed inset-0 bg-black bg-opacity-50 transition-opacity duration-300 md:hidden ${
          isOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
        }`}
        onClick={() => setIsOpen(false)}
      />

      {/* Mobile Menu Content */}
      <div
        id="mobile-menu-panel"
        role="dialog"
        aria-modal="true"
        className={`fixed right-0 top-0 h-full w-64 bg-white transform transition-transform duration-300 ease-in-out md:hidden ${
          isOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        <div className="p-6">
          <ul className="space-y-4">
            {menuItems.map((item, index) => {
              const isActive = location.pathname === item.href;
              return (
                <li key={index} className="font-semibold">
                  <Link
                    to={item.href}
                    className={`block py-2 ${
                      isActive ? 'text-black font-bold' : 'text-gray-600 hover:text-black'
                    }`}
                    onClick={() => setIsOpen(false)}
                  >
                    {item.label}
                  </Link>
                </li>
              );
            })}
            <li className="pt-4">
              <button
                className="w-full bg-black text-white text-lg font-bold px-6 py-2 rounded hover:bg-gray-800 transition-colors"
                onClick={() => {
                  navigate("/auth");
                  setIsOpen(false);
                }}
              >
                Login
              </button>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
